import React, { useContext, useCallback, useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link, Redirect } from "react-router-dom";
import {
  validateEmail,
  validatePassword,
  validateName,
  checkEqual,
} from "../../services/ValidationService";
import { useHistory } from 'react-router-dom';
import { AuthContext } from "../../context/AuthProvider";
import ModalInfo from "react-modal";
// import Custom Components
import AlertDiv from "../features/alert-div";
import "../pages/admin/styles/index.css";
import {
  getFirebaseId,
  resendUserActivationCode,
} from "../../services/UserService";
import AuthRedirectActivateAccountPage from "../pages/auth/redirect-activate-account-page";
import OptinPage from "./optin-page";
import { useTranslation } from "react-i18next";

function LoginPage(props) {
  const { t } = useTranslation();
  const [orderDetail, setOrderDetail] = useState(props.order);
  const [eventDetail, setEventDetail] = useState(props.event);
  const [loginSocialNework, setLoginSocialNework] = useState(true);
  const [loginData, setLoginData] = useState(false);
  const [loginApple, setLoginApple] = useState(false);
  const [loginEmail, setLoginEmail] = useState(false);
  const [loginOrCreate, setLoginOrCreate] = useState(props.loginOrCreate);
  const [redirectRoute, setRedirectRoute] = useState(false);
  const [userToActivate, SetUserToActivate] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [firebaseUid, setFirebaseUid] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [popUpToInstagram, setPopUpToInstagram] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [accept, setAccept] = useState({ SmsValidation: true, marketing: true });
  const {
    signUpEmailAndPassword,
    signInWithApple,
    signInWithGoogle,
    signInEmailAndPassword,
    error,
    setError,
    setLoading,
    loading,
    sent,
    loggedIn,
  } = useContext(AuthContext);

  const userAgent = navigator.userAgent;
  const infoStyles = {
    content: {
      top: "50%",
      // left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-5%, -50%)",
      borderRadius: "20px",

    },
  };

  const instagramIphone = "assets/images/instagram-iphone.png";
  const instagramAndroid = "assets/images/instagram-android.png";

  useEffect(() => { setLoading(false); setError(false) }, []);
  function handleAuthRedirectActivateAccountPageStateChange(newState) {
    setModalIsOpen(true);
  }

  const optinToLogin = (e) => {
    setAccept(e);
  };

  const handleSignUp = useCallback(async (event) => {
    try {
      setIsLoading(true);
      event.preventDefault();
      let form_valid = validateFieldSignUp();
      if (form_valid) {
        const { registerfullname, registeremailaddress, registerpassword } =
          event.target.elements;

        const data = {
          name: registerfullname.value,
          email: registeremailaddress.value,
          password: registerpassword.value,
          accept: accept,
        };
        const response = await signUpEmailAndPassword(data);
        SetUserToActivate({
          email: response.data.email,
          senha: response.data.senha,
          firebase_id: response.data.firebase_id,
        });
        setModalIsOpen(false);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  });

  const handleLogin = useCallback(async (event) => {
    setIsLoading(true);
    event.preventDefault();
    const { signinemail, signinpassword } = event.target.elements;
    try {
      const data = {
        email: signinemail.value,
        senha: signinpassword.value,
      };
      const res = await getFirebaseId(data.email);
      SetUserToActivate({
        email: data.email,
        senha: data.senha,
        firebase_id: res.data.uid,
      });
      try {
        const response = await signInEmailAndPassword(data);
      } catch (error) {
        // alert(error);
        if (error && error.code === "auth/user-disabled") {

          setModalIsOpen(false);
          setIsLoading(false);
        }
      }
    } catch (error) {
      // alert(error);
    }
    setIsLoading(false);
  });

  const validateFieldSignUp = () => {
    setError();
    let signup_email_one = document.querySelector(
      "#registeremailaddress"
    ).value;
    let signup_email_two = document.querySelector(
      "#registeremailaddress2"
    ).value;
    let signup_name = document.querySelector("#registerfullname").value;
    let password_one = document.querySelector("#registerpassword").value;
    let password_two = document.querySelector("#registerpassword2").value;

    let email_valid = validateEmail(signup_email_one);
    let password_valid = validatePassword(password_one);
    let name_valid = validateName(signup_name);
    let equal_emails = checkEqual(signup_email_one, signup_email_two);
    let equal_passwords = checkEqual(password_one, password_two);

    let valid = false;

    if (!email_valid || !equal_emails) {
      let message_error = {
        message: "Email fields must have valid emails and be the same",
      };
      setError(message_error);
    } else if (!password_valid) {
      let message_error = {
        message:
          "Your password must contain at least 1 letter, 1 number and at least 8 characters",
      };
      setError(message_error);
    } else if (!equal_passwords) {
      let message_error = { message: "The passwords don't match" };
      setError(message_error);
    } else if (!name_valid) {
      let message_error = {
        message: "You must fill in the name field with a valid full name",
      };
      setError(message_error);
    } else {
      valid = true;
    }
    return valid;
  };

  const redirectOrLoginWithGoogle = () => {
    if (userAgent.includes("Instagram")) {
      setPopUpToInstagram(true);
    } else {
      signInWithGoogle();
    }
  };

  return modalIsOpen ? (
    <div className="main">
      <div>
        {popUpToInstagram ? (
          <div>

            {
              userAgent.includes("iPhone") && (
                <span>
                  <ModalInfo isOpen={true} style={infoStyles}>
                    <h2 className="icon-box-title text-primary">
                      <i className="icon-close" onClick={() => setPopUpToInstagram(false)}
                        style={{ width: "10px", display: "flex", cursor: 'pointer', marginLeft: 'auto', marginTop: '2px' }}></i>
                    </h2>
                    <h2 className="icon-box-title text-primary">
                      {/* Instructions */}
                      {t("LoginPage.instructionsTitle")}
                    </h2>

                    <p>
                      {/* To access our ticket purchase page from Instagram, please
                      follow these steps: */}
                      {t("LoginPage.instructionsText1")}
                    </p>
                    <br />
                    <p>
                      {/* Click on the <strong>'Menu'</strong> button (
                      <strong>three dots '...'</strong>) in the top-right corner
                      of the Instagram screen. */}
                      {t("LoginPage.instructionsText2iPhone")}
                    </p>
                    <br />
                    <p>
                      {/* Select <strong>'Open in system browser'</strong> from the
                      menu options. */}
                      {t("LoginPage.instructionsText3iPhone")}
                    </p>{" "}
                    <br />
                    <img
                      src={`${process.env.PUBLIC_URL}/${instagramIphone}`}
                      alt="Groovoo Logo"
                    />
                  </ModalInfo>
                </span>
              )}

            {userAgent.includes("Android") && (
              <span>
                <ModalInfo isOpen={true} style={infoStyles}>
                  <h2 className="icon-box-title text-primary">
                    <i className="icon-close" onClick={() => setPopUpToInstagram(false)}
                      style={{ width: "10px", display: "flex", cursor: 'pointer', marginLeft: 'auto', marginTop: '2px' }}></i>
                  </h2>
                  <h2 className="icon-box-title text-primary">
                    {/* Instructions */}
                    {t("LoginPage.instructionsTitle")}
                  </h2>
                  <p>
                    {/* To access our ticket purchase page from Instagram, please
                    follow these steps: */}
                    {t("LoginPage.instructionsText1")}
                  </p>
                  <br />
                  <p>
                    {/* Click on the <strong>'Menu'</strong> button (
                    <strong>three dots '&#8942;'</strong>) in the top-right
                    corner of the Instagram screen. */}
                    {t("LoginPage.instructionsText2Android")}
                  </p>
                  <br />
                  <p>
                    {/* Select <strong>'Open in Chrome'</strong> from the menu
                    options. */}
                    {t("LoginPage.instructionsText3Android")}
                  </p>{" "}
                  <br />
                  <img
                    src={`${process.env.PUBLIC_URL}/${instagramAndroid}`}
                    alt="Groovoo Logo"
                  />
                </ModalInfo>
              </span>
            )}
          </div>
        ) : (
          <div className="">
            <div className="form-tab">
              {loginOrCreate === 1 ? (
                <Tabs
                  selectedTabClassName="show"
                // selectedTabPanelClassName="active show"
                >
                  <TabList className="nav nav-pills nav-fill">
                    <Tab className="nav-item">
                      {/* <span className="nav-link">Social </span> */}
                      <span className="nav-link">{t("LoginPage.withSocial")}</span>
                    </Tab>
                    <Tab className="nav-item">
                      {/* <span className="nav-link">Email </span> */}
                      <span className="nav-link">{t("LoginPage.withEmail")}</span>
                    </Tab>
                  </TabList>
                  <div>
                    {/* <h3 className="text-center">Sign In</h3> */}
                    <div className="form-choice">
                      <TabPanel>
                        <div>
                          {
                            <div
                              className=""
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="col-sm-6"
                                style={{ marginBottom: "0.6rem" }}
                              >
                                <button
                                  className="btn btn-login btn-g"
                                  style={{ width: "100%" }}
                                  onClick={redirectOrLoginWithGoogle}
                                >
                                  <i className="icon-google"></i>
                                  {/* Login With Google */}
                                  {t("LoginPage.signInWithGoogle")}
                                </button>
                              </div>

                              {/* <div
                              className="col-sm-6 mx-auto"
                              style={{ marginBottom: "0.6rem" }}
                            >
                              <button
                                className="btn btn-login btn-a"
                                style={{ width: "100%" }}
                                onClick={signInWithApple}
                              >
                                <i className="icon-apple"></i>
                                Login With Apple
                              </button>
                            </div> */}
                            </div>
                          }
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          {
                            <form onSubmit={handleLogin} action="#">
                              <div className="form-group">
                                <label htmlFor="signinemail">
                                  {/* Email address * */}
                                  {t("LoginPage.emailAddress")}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="signinemail"
                                  name="signinemail"
                                  required
                                />
                              </div>

                              <div className="form-group">
                                <label htmlFor="signinpassword">
                                  {/* Password * */}
                                  {t("LoginPage.password")}
                                </label>
                                <input
                                  type={showPassword ? "text" : "password"}
                                  className="form-control"
                                  id="signinpassword"
                                  name="signinpassword"
                                  required
                                />
                                <div
                                  className="password-toggle-order"
                                  onClick={() => setShowPassword(!showPassword)}
                                >
                                  <i className="icon-eye"></i>
                                </div>
                              </div>


                              {/* {!isLoading && error !== "auth/user-disabled" && (
                                <AlertDiv
                                  error
                                  title={"Sorry, authentication up error"}
                                  message={
                                    error.response
                                      ? error.response.data.message
                                      : error.message
                                  }
                                />
                              )} */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <button
                                  type="submit"
                                  disabled={loading}
                                  className="btn btn-outline-primary-2"
                                >
                                  {/* <span>LOG IN</span> */}
                                  <span>{t("LoginPage.signIn")}</span>
                                  <i className="icon-long-arrow-right"></i>
                                </button>

                                <Link
                                  to="/login/forgot-password"
                                  className="forgot-link"
                                  style={{ marginTop: "1rem" }}
                                >
                                  {/* Forgot Your Password? */}
                                  {t("LoginPage.forgotPassword")}
                                </Link>
                              </div>
                            </form>
                          }
                        </div>
                      </TabPanel>
                    </div>
                  </div>
                </Tabs>
              ) : (
                <Tabs
                  selectedTabClassName="show"
                // selectedTabPanelClassName="active show"
                >
                  <TabList className="nav nav-pills nav-fill">
                    <Tab className="nav-item">
                      {/* <span className="nav-link">Social </span> */}
                      <span className="nav-link">{t("LoginPage.withSocial")}</span>
                    </Tab>
                    <Tab className="nav-item">
                      {/* <span className="nav-link">Email </span> */}
                      <span className="nav-link">{t("LoginPage.withEmail")}</span>
                    </Tab>
                  </TabList>
                  <div>
                    {/* <h3 className="text-center">Sing Up</h3> */}

                    <div className="form-choice">
                      <TabPanel>
                        {
                          <div
                            className=""
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="col-sm-6"
                              style={{ marginBottom: "0.6rem" }}
                            >
                              <button
                                className="btn btn-login btn-g"
                                style={{ width: "100%" }}
                                onClick={redirectOrLoginWithGoogle}
                              >
                                <i className="icon-google"></i>
                                {/* Register With Google */}
                                {t("LoginPage.registerWithGoogle")}
                              </button>
                            </div>

                            {/* <div
                        className="col-sm-6 mx-auto"
                        style={{ marginBottom: "0.6rem" }}
                      >
                        <button
                          className="btn btn-login btn-a"
                          style={{ width: "100%" }}
                          onClick={signInWithApple}
                        >
                          <i className="icon-apple"></i>
                          Register With Apple
                        </button>
                      </div> */}
                          </div>
                        }
                      </TabPanel>
                    </div>

                    <div style={{ padding: "0px 15px 15px 15px" }}>
                      <TabPanel>
                        {
                          <form onSubmit={handleSignUp} action="#">
                            <div className="form-group">
                              <label htmlFor="registerfullname">
                                {/* Your Full Name * */}
                                {t("LoginPage.yourFullName")}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="registerfullname"
                                name="registerfullname"
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="registeremailaddress">
                                {/* Email address * */}
                                {t("LoginPage.emailAddress")}
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="registeremailaddress"
                                name="registeremailaddress"
                                required
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="registeremailaddress2">
                                {/* Confirm email address * */}
                                {t("LoginPage.confirmEmailAddress")}
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="registeremailaddress2"
                                name="registeremailaddress2"
                                required
                              />
                            </div>

                            <div className="form-group">
                              <label htmlFor="registerpassword">
                                {t("LoginPage.password")}
                              </label>
                              <div className="password-container">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  minLength="8"
                                  className="form-control"
                                  id="registerpassword"
                                  name="registerpassword"
                                  required
                                />
                                <div
                                  className="password-toggle"
                                  onClick={() => setShowPassword(!showPassword)}
                                >
                                  <i className={"icon-eye"}></i>
                                </div>
                              </div>
                            </div>

                            <div className="form-group">
                              <label htmlFor="registerpassword2">{t("LoginPage.confirmPassword")}</label>
                              <div className="password-container">
                                <input
                                  type={showConfirmPassword ? "text" : "password"}
                                  className="form-control"
                                  id="registerpassword2"
                                  name="registerpassword2"
                                  minLength="8"
                                  required
                                />
                                <div
                                  className="password-toggle"
                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                  <i className={"icon-eye"}></i>
                                </div>
                              </div>
                            </div>

                            {error && (
                              <AlertDiv
                                error
                                title={"Sorry, sign up error"}
                                message={
                                  error.response
                                    ? error.response.data.message
                                    : error.message
                                }
                              />
                            )}

                            <div className="">
                              <button
                                type="submit"
                                disabled={loading || sent}
                                className="btn btn-outline-primary-2"
                              >
                                {/* <span>SIGN UP</span> */}
                                <span>{t("LoginPage.register")}</span>
                                <i className="icon-long-arrow-right"></i>
                              </button>

                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="registerpolicy"
                                  required
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="registerpolicy"
                                >
                                  {/* I agree to the{" "} */}
                                  {t("LoginPage.iAgreeToThe")}{" "}
                                  <a
                                    href="https://groovoo.io/terms.html"
                                    target="blank"
                                  >
                                    {/* privacy policy */}
                                    {t("LoginPage.privacyPolicy")}
                                  </a>{" "}
                                  *
                                </label>
                              </div>
                              <OptinPage optinToLogin={optinToLogin} />
                            </div>
                          </form>
                        }
                      </TabPanel>
                    </div>
                  </div>
                </Tabs>
              )}
            </div>
          </div>
        )}
      </div>

      <div>
        {loggedIn && (
          <Redirect
            to={{
              pathname: `${process.env.PUBLIC_URL}/shop/checkout`,
              state: {
                event: eventDetail,
                order: orderDetail,
              },
            }}
          />
        )}
      </div>
    </div>
  ) : !isLoading && (error.code === "auth/user-disabled" || userToActivate) ? (
    <AuthRedirectActivateAccountPage
      location={{
        state: {
          event: props.event,
          order: props.order,
          userToActivate: userToActivate,
        },
      }}
      onStateChange={handleAuthRedirectActivateAccountPageStateChange}
      onClose={() => setModalIsOpen(true)}
    ></AuthRedirectActivateAccountPage>
  ) : null;
}

export default LoginPage;
